import { LabelSmall, LabelXSmall, ParagraphSmall, ParagraphXSmall } from "baseui/typography"
import { ROOM_USAGE, RoomTypes } from "./types"
import { FormattedMessage } from "react-intl"
import { Block } from "baseui/block"
import { useStyletron } from "baseui"


export const OptimalConditionsText = (props: { roomUsage: ROOM_USAGE }) => {
const [css,theme] = useStyletron();
    const roomType = RoomTypes.find(v => v.id === props.roomUsage);

    return (<>
        {roomType &&
            <>
                <Block display={'inline-flex'} gridGap={'10px'} alignItems={'baseline'}>
                    <LabelXSmall color={theme.colors.contentTertiary}>
                        <FormattedMessage id="SubPlants.OptimalConditions" defaultMessage="Optimal Conditions" />:
                    </LabelXSmall>

                    <ParagraphXSmall color={theme.colors.contentTertiary} margin={0}>
                        <FormattedMessage id="SubPlants.Temperature" defaultMessage="Temperature " /> {roomType.tempLow.toFixed(1)}-{roomType.tempHigh.toFixed(1)}°C
                    </ParagraphXSmall>
                    <ParagraphXSmall color={theme.colors.contentTertiary} margin={0}>
                        <FormattedMessage id="SubPlants.Humidity" defaultMessage="Humidity " /> {roomType.humLow.toFixed(1)}-{roomType.humHigh.toFixed(1)}%
                    </ParagraphXSmall>
                </Block>
            </>
        }
    </>)

}